module.exports = __webpack_public_path__ + "static/media/gen_img10.4b8dca06.png";